declare const Handlebars: any;

export const HTML_TEMPLATE_SYSTEM_TOKEN = Symbol('HTML_TEMPLATE_SYSTEM_TOKEN');

class HtmlTemplateSystem {
  public build(html: string, data: any): string {
    const template = Handlebars.compile(html);
    return template(data);
  }
}

export const htmlTemplateSystem = new HtmlTemplateSystem();
